import debounce from 'lodash/debounce';
import ReactTooltip from 'react-tooltip';

export const createDebouncedRebuildReactTooltip = (debounceTime: number = 200) =>
  debounce(ReactTooltip.rebuild, debounceTime);

export const debouncedRebuildReactTooltip = createDebouncedRebuildReactTooltip();
